import { env } from "./util/env";

export function registerServiceWorker(isProduction = env.MODE === "production") {
  if (isProduction && "serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/sw.js", { type: "module" })
      .then(registration => {
        console.log("Service Worker registered with scope:", registration.scope);
      })
      .catch(error => {
        console.error("Service Worker registration failed:", error);
      });
  }
}
